import * as moment from 'moment';
import { Action, combineReducers } from '@ngrx/store';

import { Job, Order } from '../../app/models';
import { shipmentTypes } from '../shipment-options';
import { REPRINT, SHIPMENTS } from '../status-types';

import {
  _CLEAR,
  CREATE_ORDER,
  DELETE_ORDER,
  GET_MID_ORDERS,
  GET_ORDER,
  GET_ORDERS,
  GET_FILTERED_ORDERS,
  UPDATE_JOB,
  UPDATE_JOBS,
  UPDATE_MID_ORDER,
  UPDATE_ORDER,
  UPDATE_ORDERS,
  SET_ORDER_LIST_VIEW,
  SET_ORDER_DETAILS_VIEW,
  GET_COMMENT_MAP,
  SET_COMMENT_ORDERS_MAP,
  SET_COMMENT_JOBS_MAP,
  SET_COMMENT_SHIPMENT_MAP,
  GET_AMAZON_ORDERS,
  GET_MARKETPLACE_ORDERS,
  GET_PTO_ORDERS,
  UPDATE_PTO_ORDER
} from '../actions';

const initialOrderDetailsState = {
  addressValidationMsg: <{
    type       : string,
    msg        : string,
    msgIcon    : string,
    suggestions: any[]
  }>{ type: '', msg: '', msgIcon: '', suggestions: [] },
  allJobsReady: <boolean>false,
  loading     : <boolean>false,
  error       : <string>''
};

const initialOrderListViewState = {
  loading: <boolean>false
};

const initialCurrentlyDueOrdersState = {
  orders: <Order[]>[],
  jobs  : <number>0
};

const initialHasCommentState = {
  orders: Object,
  jobs  : Object,
  shipments : Object
};

export function mailInnovationsOrderListReducer(state = [], action: Action) {
  switch (action.type) {
    case _CLEAR: 
      return [];
    case GET_MID_ORDERS: 
      return action.payload.MID_orders;
    case UPDATE_MID_ORDER:
      return state.map(order => {
        return order.id === action.payload.order.id
          ? updateMidOrder(order,action.payload.order.include)
          : order;
      });
    default: 
      return state;
  }
}

export function orderDetailsReducer(state = initialOrderDetailsState, action: Action) {
  switch (action.type) {
    case _CLEAR: 
      return Object.assign({}, state, initialOrderDetailsState);
    case SET_ORDER_DETAILS_VIEW: 
      return Object.assign({}, state, action.payload);
    default: 
      return state;
  }
}

export function orderListViewReducer(state = initialOrderListViewState, action: Action) {
  switch (action.type) {
    case _CLEAR: 
      return Object.assign({}, state, initialOrderListViewState);
    case SET_ORDER_LIST_VIEW: 
      return Object.assign({}, state, action.payload);
    default: 
      return state;
  }
}

export function currentlyDueOrdersReducer(state = initialCurrentlyDueOrdersState, action: Action) {
  switch (action.type) {
    case GET_FILTERED_ORDERS:
      return Object.assign({}, state, {
        orders: action.payload.currentlyDueOrders,
        jobs: action.payload.currentlyDueJobs
      });
    default:
      return state;
  }
}

export function orderCommentsReducer(state = initialHasCommentState, action: Action) {
  // console.log("ORDER COMMENT REDUCER : ", action.payload)
  switch (action.type) {
    case GET_COMMENT_MAP:
      return Object.assign({}, state, {
        orders: action.payload.ordersCommentMap,
        jobs: action.payload.jobsCommentMap
      });
    case SET_COMMENT_ORDERS_MAP:
      return Object.assign({}, state, {
        orders: action.payload.ordersCommentMap
      });
    case SET_COMMENT_JOBS_MAP:
      return Object.assign({}, state, {
        jobs: action.payload.jobsCommentMap
      });
    case SET_COMMENT_SHIPMENT_MAP:
      return Object.assign({}, state, {
        shipments: action.payload.shipmentsCommentMap
      });
    default:
      return state;
  }
}

export function dueTodayOrderListReducer(state = [], action: Action) {
  switch (action.type) {
    case GET_FILTERED_ORDERS:
      return action.payload.dueTodayOrders;
    default:
      return state;
  }
}

// export function dueTomorrowOrderListReducer(state = [], action: Action) {
//   switch (action.type) {
//     case GET_FILTERED_ORDERS:
//       return action.payload.dueTomorrowOrders;
//     default:
//       return state;
//   }
// }
export function addressInvalidOrderListReducer(state = [], action: Action) {
  switch (action.type) {
    case GET_FILTERED_ORDERS:
      return action.payload.addressInvalidOrders;
    default:
      return state;
  }
}


export function dueNextBusinessDayOrdersListReducer(state = [], action: Action) {
  switch (action.type) {
    case GET_FILTERED_ORDERS:
      return action.payload.dueNextBusinessDayOrders;
    default:
      return state;
  }
}

export function reprintOverdueOrderListReducer(state = [], action: Action) {
  switch (action.type) {
    case GET_FILTERED_ORDERS: 
      return action.payload.reprintOverdueOrders;
    default: 
      return state;
  }
}

export function overdueOrderListReducer(state = [], action: Action) {
  switch (action.type) {
    case GET_FILTERED_ORDERS: 
      return action.payload.overdueOrders;
    default: 
      return state;
  }
}

export function RTSOrderListReducer(state = [], action: Action) {
  switch (action.type) {
    case GET_FILTERED_ORDERS: 
      return action.payload.RTSOrders;
    default: 
      return state;
  }
}

export function reprintOrderListReducer(state = [], action: Action) {
  switch (action.type) {
    case GET_FILTERED_ORDERS: 
      return action.payload.reprintOrders;
    default: 
      return state;
  }
}

export function normalOrderListReducer(state = [], action: Action) {
  switch (action.type) {
    case GET_FILTERED_ORDERS: 
      return action.payload.normalOrders;
    default: 
      return state;
  }
}

export function serviceTypeSelectListReducer(state = [], action: Action) {
  switch (action.type) {
    case GET_FILTERED_ORDERS: 
      return action.payload.serviceTypeSelect;
    default: 
      return state;
  }
}

export function deliveryDateSelectListReducer(state = [], action: Action) {
  switch (action.type) {
    case GET_FILTERED_ORDERS: 
      return action.payload.deliveryDateSelect;
    default: 
      return state;
  }
}

export function customerDueDateSelectListReducer(state = [], action: Action) {
  switch (action.type) {
    case GET_FILTERED_ORDERS: 
      return action.payload.customerDueDateSelect;
    default: 
      return state;
  }
}

export function dueDateSelectListReducer(state = [], action: Action) {
  switch (action.type) {
    case GET_FILTERED_ORDERS: 
      return action.payload.dueDateSelect;
    default: 
      return state;
  }
}

export function daysUntilDueSelectListReducer(state = [], action: Action) {
  switch (action.type) {
    case GET_FILTERED_ORDERS: 
      return action.payload.daysUntilDueSelect;
    default: 
      return state;
  }
}

export function pendingPrintOrderListReducer(state = [], action: Action) {
  switch (action.type) {
    case GET_FILTERED_ORDERS: 
      return action.payload.pendingPrintOrders;
    default: 
      return state;
  }
}

export function prePressOrderListReducer(state = [], action: Action) {
  switch (action.type) {
    case GET_FILTERED_ORDERS: 
      return action.payload.prePressOrders;
    default: 
      return state;
  }
}

export function amazonOrderListReducer(state = [], action: Action) {
  switch (action.type) {
    case GET_AMAZON_ORDERS: 
      // return action.payload.amazonOrders;
      return action.payload.amazonOrders.length
      ? action.payload.amazonOrders.sort(sortOrders)
      : state;
    default: 
      return state;
  }
}

export function ptoOrderListReducer(state = [], action: Action) {
  switch (action.type) {
    case GET_PTO_ORDERS: 
      // return action.payload.amazonOrders;
      return action.payload.ptoOrders.length
      ? action.payload.ptoOrders.sort(sortOrders)
      : state;
    default: 
      return state;
  }
}

export function marketplaceOrderListReducer(state = [], action: Action) {
  switch (action.type) {
    case GET_MARKETPLACE_ORDERS: 
      return action.payload.marketplaceOrders.length
      ? action.payload.marketplaceOrders.sort(sortOrders)
      : state;
    default: 
      return state;
  }
}

export function orderListReducer(state = [], action: Action) {
  switch (action.type) {
    case _CLEAR: 
      return [];
    case CREATE_ORDER: 
      const match = state.find(order => action.payload.order && order.id === action.payload.order.id);
      return !match
        ? [ ...state, action.payload.order ].sort(sortOrders)
        : state;
    case DELETE_ORDER: 
      return state.filter(order => order.id !== action.payload.id);
    case GET_ORDERS: 
      return action.payload.orders.length
        ? action.payload.orders.sort(sortOrders)
        : state;
    case UPDATE_ORDER: 
      return state.map(order => {
        return order.id === action.payload.order.id
          ? action.payload.order
          : order;
      });
    case UPDATE_ORDERS: 
      return state.map(stateOrder => {
        const match = action.payload.orders.find(order => order.id === stateOrder.id);
        return !match ? stateOrder: match;
      });
    default: 
      return state;
  }
}

function sortOrders(order1, order2) {
  const date1 = moment(order1.shipment.production_due_date).format('x');
  const date2 = moment(order2.shipment.production_due_date).format('x');

  return +date1 - +date2;     // Date Descending
}

function updateMidOrder(midOrder, include): any {
  if(midOrder.include !== include ) {
    midOrder.include = include;
  }
  return midOrder;
}

export const orderReducers = combineReducers({
  addressInvalidOrderList : addressInvalidOrderListReducer, 
  mailInnovationsOrderList: mailInnovationsOrderListReducer,
  orderDetails            : orderDetailsReducer,
  orderList               : orderListReducer,
  orderListView           : orderListViewReducer,
  currentlyDueOrders      : currentlyDueOrdersReducer,
  dueTodayOrderList       : dueTodayOrderListReducer,
  // dueTomorrowOrderList    : dueTomorrowOrderListReducer,
  dueNextBusinessDayOrdersList    : dueNextBusinessDayOrdersListReducer,
  reprintOverdueOrderList : reprintOverdueOrderListReducer,
  overdueOrderList        : overdueOrderListReducer,
  RTSOrderList            : RTSOrderListReducer,
  reprintOrderList        : reprintOrderListReducer,
  normalOrderList         : normalOrderListReducer,
  pendingPrintOrderList   : pendingPrintOrderListReducer,
  prePressOrderList       : prePressOrderListReducer,
  serviceTypeSelectList   : serviceTypeSelectListReducer,
  deliveryDateSelectList  : deliveryDateSelectListReducer,
  customerDueDateSelectList  : customerDueDateSelectListReducer,
  dueDateSelectList       : dueDateSelectListReducer,
  daysUntilDueSelectList  : daysUntilDueSelectListReducer,
  amazonOrderList         : amazonOrderListReducer,
  marketplaceOrderList    : marketplaceOrderListReducer,
  ptoOrderList            : ptoOrderListReducer,
  orderCommentsMap        : orderCommentsReducer
});



// WEBPACK FOOTER //
// /Users/itu/Desktop/impreso_updated_sheets/impresocloud/www/client/src/ngrx/reducers/orders.ts